import React from "react";

const FPUOverviewContent = () => {
  return (
    <div className="p-8">
      <div className="space-y-8">
        {/* Definition Section */}
        <div className="bg-base-200 rounded-xl p-6">
          <h2 className="text-2xl font-bold mb-6">Apa itu FPU?</h2>
          <p className="leading-relaxed text-base-content/70">
            Unit polisi bersenjata yang bergerak, khusus, dan berbentuk kesatuan
            yang menyelenggarakan keamanan bagi operasi PBB dengan menjamin
            keselamatan dan keamanan personel dan aset PBB, berkontribusi dalam
            perlindungan masyarakat sipil dan mendukung operasi kepolisian.
          </p>
        </div>

        {/* Mandate & Capabilities */}
        <div className="bg-base-200 rounded-xl p-6">
          <h2 className="text-2xl font-bold mb-6">Mandat dan Kemampuan</h2>
          <div className="space-y-4">
            <p className="leading-relaxed text-base-content/70">
              Berdasarkan mandat yang diberikan, FPU dapat melaksanakan
              tugas-tugas dimaksud secara mandiri atau mendukung institusi
              penegak hukum lokal yang sudah ada sesuai dengan kemampuan
              operasional dan logistik, daerah penugasan dan kebijakan PBB yang
              berlaku.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
              <div className="bg-base-100 rounded-lg p-4">
                <h3 className="font-semibold text-lg mb-3">Kemampuan Khusus</h3>
                <ul className="space-y-2 text-base-content/70">
                  <li className="flex items-start gap-2">
                    <span className="text-primary">•</span>
                    <span>Unit satwa (K9)</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-primary">•</span>
                    <span>Pengamanan melekat (pengawal pribadi)</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-primary">•</span>
                    <span>Penyidik/forensik</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-primary">•</span>
                    <span>Penanganan huru-hara</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-primary">•</span>
                    <span>Unit SWAT</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-primary">•</span>
                    <span>Polisi perairan</span>
                  </li>
                </ul>
              </div>

              <div className="bg-base-100 rounded-lg p-4">
                <h3 className="font-semibold text-lg mb-3">Tugas Utama</h3>
                <ul className="space-y-2 text-base-content/70">
                  <li className="flex items-start gap-2">
                    <span className="text-secondary">•</span>
                    <span>Menjamin keselamatan personel PBB</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-secondary">•</span>
                    <span>Melindungi aset PBB</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-secondary">•</span>
                    <span>Perlindungan masyarakat sipil</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-secondary">•</span>
                    <span>Mendukung operasi kepolisian</span>
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="text-secondary">•</span>
                    <span>Penegakan hukum dan ketertiban</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Deployment Standards */}
        <div className="bg-base-200 rounded-xl p-6">
          <h2 className="text-2xl font-bold mb-6">Standar Penugasan</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-base-100 rounded-lg p-4 text-center">
              <div className="text-3xl mb-3">⏱️</div>
              <h3 className="font-semibold text-lg mb-2">Durasi Standar</h3>
              <p className="text-primary font-bold text-2xl">1 Tahun</p>
              <p className="text-sm text-base-content/70 mt-1">
                Dapat diperpanjang hingga 18 bulan
              </p>
            </div>

            <div className="bg-base-100 rounded-lg p-4 text-center">
              <div className="text-3xl mb-3">👥</div>
              <h3 className="font-semibold text-lg mb-2">Kekuatan</h3>
              <p className="text-secondary font-bold text-2xl">140</p>
              <p className="text-sm text-base-content/70 mt-1">
                Personel per kontingen
              </p>
            </div>

            <div className="bg-base-100 rounded-lg p-4 text-center">
              <div className="text-3xl mb-3">🔄</div>
              <h3 className="font-semibold text-lg mb-2">Sistem</h3>
              <p className="text-accent font-bold text-xl">COE</p>
              <p className="text-sm text-base-content/70 mt-1">
                Contingent Owned Equipment
              </p>
            </div>
          </div>
        </div>

        {/* Assessment Process */}
        <div className="bg-base-200 rounded-xl p-6">
          <h2 className="text-2xl font-bold mb-6">
            Proses Penilaian dan Persiapan
          </h2>
          <div className="space-y-4">
            <p className="leading-relaxed text-base-content/70">
              Tugas pokok dan komposisi dari FPU, termasuk personel (kekuatan,
              kemampuan, perintah dan pengawasan pengendalian, kemampuan khusus,
              dan sebagainya), serta melengkapi persyaratan yang telah
              ditentukan didalam tahap penilaian pada proses:
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="bg-primary/10 rounded-lg p-4 border-l-4 border-primary">
                <h3 className="font-semibold text-lg mb-2">PCRS</h3>
                <p className="text-sm text-base-content/70">
                  Peacekeeping Capability Readiness System - Sistem penilaian
                  kesiapan kemampuan pemeliharaan perdamaian
                </p>
              </div>

              <div className="bg-secondary/10 rounded-lg p-4 border-l-4 border-secondary">
                <h3 className="font-semibold text-lg mb-2">SUR</h3>
                <p className="text-sm text-base-content/70">
                  Statement of Unit Requirement - Pernyataan persyaratan unit
                  yang harus dipenuhi
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Current Mission */}
        <div className="bg-gradient-to-r from-primary/20 to-secondary/20 rounded-xl p-6">
          <h2 className="text-2xl font-bold mb-6">Misi Aktif Saat Ini</h2>
          <div className="bg-base-100 rounded-lg p-6">
            <div className="flex items-center gap-4 mb-4">
              <div className="text-4xl">🇨🇫</div>
              <div>
                <h3 className="text-xl font-bold">MINUSCA</h3>
                <p className="text-base-content/70">
                  United Nations Multidimensional Integrated Stabilization
                  Mission in the Central African Republic
                </p>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
              <div className="text-center">
                <p className="font-semibold">Lokasi</p>
                <p className="text-base-content/70">Republik Afrika Tengah</p>
              </div>
              <div className="text-center">
                <p className="font-semibold">Kontingen</p>
                <p className="text-base-content/70">Garuda Bhayangkara</p>
              </div>
              <div className="text-center">
                <p className="font-semibold">Personel</p>
                <p className="text-primary font-bold">140 Personel</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FPUOverviewContent;
